import type { ICampaignMetricMinimal } from "../../../../types/models/campaign-metric.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  metrics: ICampaignMetricMinimal;
}

export function useGetCampaignMetricsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:id/metrics",
  });
}
